<p-toast position="top-center" role="status" aria-live="polite" aria-atomic="true"></p-toast>

<p-confirmDialog role="alertdialog" aria-modal="true"></p-confirmDialog>

<div class="checklist-config-container">
  <!-- Breadcrumb -->
  <nav class="mb-4" aria-label="Breadcrumb">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{ icon: 'pi pi-home', routerLink: '/axa/professionals-dashboard' }"
    >
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <section class="page-header mb-4" aria-labelledby="checklist-config-title">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-check-square header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 id="checklist-config-title">{{ checklistId ? 'Modifica Checklist' : 'Crea Checklist' }}</h1>
          <p class="subtitle">Definisci il template di raccolta files per tipo di fiduciario</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Main Form Card -->
  <main class="card-container surface-card shadow-2 border-round-xl p-4 md:p-5" role="main">
    <div class="checklist-card">
      <form [formGroup]="form" class="p-fluid checklist-form">
      <!-- Info Base -->
      <div class="grid-container">
        <div class="field field-group">
          <label for="name">
            Nome Checklist <span class="required-marker" aria-label="campo obbligatorio">*</span>
          </label>
          <div class="p-inputgroup">
            <input
              pInputText
              id="name"
              formControlName="name"
              placeholder="Inserisci il nome..."
              [attr.aria-required]="'true'"
              [attr.aria-invalid]="
                form.get('name')?.invalid && form.get('name')?.touched ? 'true' : 'false'
              "
              [attr.aria-describedby]="
                form.get('name')?.invalid && form.get('name')?.touched ? 'name-error' : null
              "
            />
          </div>
          @if (form.get('name')?.invalid && form.get('name')?.touched) {
            <small
              id="name-error"
              class="p-error block mt-2 ml-2 font-semibold"
              role="alert"
              aria-live="assertive"
            >
              <i class="pi pi-exclamation-circle mr-1" aria-hidden="true"></i> Il nome è
              obbligatorio
            </small>
          }
        </div>

        <!-- Sezione Tipo Fiduciario -->
        <div class="field field-group">
          <label for="trusteeTypes" class="block font-bold text-900">
            Tipi di Fiduciario <span class="required-marker" aria-label="campo obbligatorio">*</span>
          </label>
          <p-multiselect
            id="trusteeTypes"
            [options]="trusteeTypes()"
            formControlName="trusteeTypes"
            optionLabel="name"
            optionValue="code"
            placeholder="Seleziona una o più categorie..."
            display="chip"
            [maxSelectedLabels]="2"
            styleClass="w-full"
            ariaLabel="Tipi di Fiduciario"
            [showClear]="true"
            [filter]="true"
            [attr.aria-required]="'true'"
            [attr.aria-invalid]="
              form.get('trusteeTypes')?.invalid && form.get('trusteeTypes')?.touched
                ? 'true'
                : 'false'
            "
            [attr.aria-describedby]="
              form.get('trusteeTypes')?.invalid && form.get('trusteeTypes')?.touched
                ? 'trusteeTypes-error'
                : null
            "
          >
          </p-multiselect>
          @if (form.get('trusteeTypes')?.invalid && form.get('trusteeTypes')?.touched) {
            <small
              id="trusteeTypes-error"
              class="p-error block mt-2 font-semibold"
              role="alert"
              aria-live="assertive"
            >
              <i class="pi pi-exclamation-circle mr-1" aria-hidden="true"></i> Seleziona almeno una tipologia
            </small>
          }
        </div>
      </div>
      <!-- CHIUSURA GRID-CONTAINER MANCANTE AGGIUNTA QUI -->

      <div class="relative my-6">
        <hr class="border-top-1 border-200" />
      </div>

      <!-- Sezione Documenti -->
      <section class="items-header" aria-labelledby="required-documents-title">
        <div>
          <h3 id="required-documents-title">
            Documenti Richiesti <span class="required-marker" aria-label="almeno un documento obbligatorio">*</span>
          </h3>
          <p class="text-sm text-600 mt-1 mb-0">Aggiungi almeno un documento alla checklist</p>
        </div>
        <p-button
          label="Aggiungi Documento"
          icon="pi pi-plus"
          (onClick)="openItemDialog()"
          [rounded]="true"
          ariaLabel="Aggiungi un nuovo documento richiesto"
          title="Aggiungi un nuovo documento richiesto"
        ></p-button>
      </section>

      <div
        class="items-list"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        role="list"
        aria-label="Elenco documenti richiesti"
      >
        @for (item of items.controls; let i = $index; track item) {
          <div class="item-row" cdkDrag role="listitem" [attr.aria-labelledby]="'item-label-' + i">
            <div class="item-info">
              <div
                class="drag-handle"
                cdkDragHandle
                tabindex="0"
                role="button"
                [attr.aria-label]="'Trascina per riordinare il documento: ' + item.value.label"
                [attr.title]="'Trascina per riordinare il documento: ' + item.value.label"
              >
                <i class="pi pi-ellipsis-v" aria-hidden="true"></i>
                <i class="pi pi-ellipsis-v" style="margin-top: -8px" aria-hidden="true"></i>
              </div>
              <div class="item-icon"><i class="pi pi-file" aria-hidden="true"></i></div>
              <div class="item-details">
                <span class="item-label" [attr.id]="'item-label-' + i">{{ item.value.label }}</span>
                <div class="item-tags">
                  @for (type of item.value.allowedTypes; track type) {
                    <p-tag [value]="formatMime(type)" severity="secondary" [rounded]="true"></p-tag>
                  }
                  @if (item.value.exampleFileName) {
                    <p-tag
                      value="Esempio"
                      icon="pi pi-download"
                      severity="info"
                      [rounded]="true"
                      style="cursor:pointer"
                      (click)="downloadItemTemplate(item)"
                      [title]="'Scarica ' + item.value.exampleFileName"
                    ></p-tag>
                  }
                  @if (item.value.hasExpirationDate) {
                    <p-tag
                      value="Con Scadenza"
                      icon="pi pi-calendar"
                      severity="warn"
                      [rounded]="true"
                    ></p-tag>
                  }
                    <p-tag
                      [value]="item.value.isMandatory ? 'Obbligatorio' : 'Opzionale'"
                      [severity]="item.value.isMandatory ? 'warn' : 'success'"
                      [rounded]="true"
                    ></p-tag>
                </div>
              </div>
            </div>
            <div class="flex align-items-center gap-2">
              <p-button
                icon="pi pi-pencil"
                [text]="true"
                severity="secondary"
                (onClick)="editItem(i)"
                [ariaLabel]="'Modifica documento: ' + item.value.label"
                [attr.title]="'Modifica documento: ' + item.value.label"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                [text]="true"
                severity="danger"
                (onClick)="removeItem(i)"
                [ariaLabel]="'Elimina documento: ' + item.value.label"
                [attr.title]="'Elimina documento: ' + item.value.label"
              ></p-button>
            </div>
          </div>
        } @empty {
          <div class="empty-state" role="status" aria-live="polite">
            <i class="pi pi-cloud-upload" aria-hidden="true"></i>
            <p class="font-semibold text-lg mb-2">Nessun documento aggiunto</p>
            <p class="text-600">Aggiungi almeno un documento obbligatorio per completare la checklist</p>
          </div>
        }
      </div>

      <div class="form-footer flex justify-content-end gap-3 w-full"
        role="group"
        [attr.aria-label]="'Azioni form checklist'">
        <p-button
          label="Annulla"
          [outlined]="true"
          (onClick)="navigateToList()"
          [attr.aria-label]="'Annulla e torna al registro checklist'"
          [attr.title]="'Annulla e torna al registro checklist'"
        ></p-button>
        <p-button
          [label]="checklistId ? 'Salva Modifiche' : 'Salva'"
          icon="pi pi-check"
          iconPos="right"
          severity="primary"
          (onClick)="submit()"
          [disabled]="form.invalid || items.length === 0"
          [attr.aria-label]="checklistId ? 'Salva le modifiche alla checklist' : 'Salva la nuova checklist'"
          [attr.title]="form.invalid || items.length === 0 ? getValidationMessage() : (checklistId ? 'Salva le modifiche alla checklist' : 'Salva la nuova checklist')"
          [pTooltip]="form.invalid || items.length === 0 ? getValidationMessage() : ''"
          tooltipPosition="top"
        ></p-button>
      </div>
    </form>
  </div>
</main>

<!-- Dialog -->
<p-dialog
  [(visible)]="showItemDialog"
  [modal]="true"
  [style]="{ width: '450px' }"
  class="checklist-dialog"
  (onHide)="onItemDialogHide()"
  [closeAriaLabel]="'Chiudi dialog requisito documento'"
  aria-labelledby="item-dialog-title"
>
  <ng-template pTemplate="header">
    <span id="item-dialog-title">
      {{ editingItemIndex !== null ? 'Modifica Requisito' : 'Nuovo Requisito' }}
    </span>
  </ng-template>

  <div class="dialog-content" role="region" aria-labelledby="item-dialog-title">

    <!-- Nota campi obbligatori -->
    <p class="text-sm text-600 mb-3 mt-0">
      I campi contrassegnati con <span class="required-marker" aria-label="obbligatorio">*</span> sono obbligatori.
    </p>

    <!-- Nome documento -->
    <div class="field-group mb-3">
      <label for="item-label-input" class="font-bold">
        Nome documento <span class="required-marker" aria-label="obbligatorio">*</span>
      </label>
      <input
        pInputText
        id="item-label-input"
        [(ngModel)]="itemForm.label"
        placeholder="Es: Foto Patente"
        [class.ng-invalid]="isItemLabelInvalid() && itemDialogValidationAttempted"
        [class.ng-dirty]="itemDialogValidationAttempted"
        [attr.aria-required]="'true'"
        [attr.aria-invalid]="isItemLabelInvalid() && itemDialogValidationAttempted ? 'true' : 'false'"
        [attr.aria-describedby]="isItemLabelInvalid() && itemDialogValidationAttempted ? 'item-label-error' : null"
      />
      @if (isItemLabelInvalid() && itemDialogValidationAttempted) {
        <small id="item-label-error" class="p-error block mt-1" role="alert" aria-live="assertive">
          <i class="pi pi-exclamation-circle mr-1" aria-hidden="true"></i>Il nome documento è obbligatorio
        </small>
      }
    </div>

    <!-- Formati ammessi -->
    <div
      class="field-group mb-3"
      role="group"
      aria-labelledby="allowed-types-legend"
      [attr.aria-describedby]="isAllowedTypesInvalid() && itemDialogValidationAttempted ? 'allowed-types-error' : null"
    >
      <label id="allowed-types-legend" class="font-bold">
        Formati ammessi <span class="required-marker" aria-label="obbligatorio">*</span>
      </label>
      <p class="text-sm text-600 mt-1 mb-2">Seleziona almeno un formato accettato per questo documento</p>
      <div class="checkbox-grid">
        @for (ext of fileExtensions; track ext.value; let extIndex = $index) {
          <div class="checkbox-item">
            <p-checkbox
              [value]="ext.value"
              [(ngModel)]="itemForm.allowedTypes"
              [inputId]="'allowed-type-' + extIndex"
            ></p-checkbox>
            <label [for]="'allowed-type-' + extIndex" class="ml-2">{{ ext.label }}</label>
          </div>
        }
      </div>
      @if (isAllowedTypesInvalid() && itemDialogValidationAttempted) {
        <small id="allowed-types-error" class="p-error block mt-1" role="alert" aria-live="assertive">
          <i class="pi pi-exclamation-circle mr-1" aria-hidden="true"></i>Seleziona almeno un formato ammesso
        </small>
      }
    </div>

    <!-- Obbligatorietà documento -->
    <div class="field-group mb-3">
      <label class="font-bold block mb-2">Obbligatorietà</label>
      <div class="flex align-items-center gap-2">
        <p-checkbox
          [(ngModel)]="itemForm.isMandatory"
          [binary]="true"
          inputId="isMandatory"
          [attr.aria-describedby]="'isMandatory-hint'"
        ></p-checkbox>
        <label for="isMandatory" class="ml-1">
          Il documento è obbligatorio per il fiduciario
        </label>
      </div>
      <small id="isMandatory-hint" class="text-600 text-sm mt-1 block">
        Se deselezionato il documento sarà facoltativo
      </small>
    </div>

    <!-- Scadenza documento -->
    <div class="field-group mb-4">
      <label class="font-bold block mb-2">Scadenza</label>
      <div class="flex align-items-center gap-2">
        <p-checkbox
          [(ngModel)]="itemForm.hasExpirationDate"
          [binary]="true"
          inputId="hasExpirationDate"
          [attr.aria-describedby]="'hasExpirationDate-hint'"
        ></p-checkbox>
        <label for="hasExpirationDate" class="ml-1">
          Il documento ha una data di scadenza
        </label>
      </div>
      <small id="hasExpirationDate-hint" class="text-600 text-sm mt-1 block">
        Il fiduciario dovrà indicare la data di scadenza al momento del caricamento
      </small>
    </div>

    <!-- Checkbox: ha un file template? -->
    <div class="field-group mb-3">
      <div class="flex align-items-center gap-2">
        <p-checkbox
          inputId="isTemplateFilePresent"
          [(ngModel)]="itemForm.isTemplateFilePresent"
          [binary]="true"
          (onChange)="onTemplateToggle()"
          [attr.aria-describedby]="'template-hint'"
        ></p-checkbox>
        <label for="isTemplateFilePresent" class="font-bold cursor-pointer">
          Ha un file template
        </label>
      </div>
      <small id="template-hint" class="text-600 text-sm mt-1 block">
        Carica un template o fac-simile da mostrare al fiduciario come riferimento
      </small>
    </div>

    <!-- Upload File Esempio/Template — visibile solo se isTemplateFilePresent=true -->
    @if (itemForm.isTemplateFilePresent) {
    <div class="field-group mb-4">
      <label id="example-file-label" class="font-bold">
        File Template
      </label>
      <p-fileUpload
        #exampleFileUpload
        name="exampleFile"
        [auto]="false"
        [customUpload]="true"
        [maxFileSize]="10000000"
        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png"
        (onSelect)="onSelectExample($event)"
        [showUploadButton]="false"
        [showCancelButton]="false"
        styleClass="custom-fileupload"
        [attr.aria-labelledby]="'example-file-label'"
        class="w-full"
      >
        <ng-template pTemplate="header"></ng-template>
        <ng-template
          pTemplate="content"
          let-files
          let-chooseCallback="chooseCallback"
          let-clearCallback="clearCallback"
        >
          @if (itemForm.exampleFile) {
            <div class="p-3">
              <div class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round mb-2">
                <div class="flex align-items-center gap-3">
                  <i class="pi pi-file text-3xl text-primary" aria-hidden="true"></i>
                  <div>
                    <div class="font-semibold text-900">{{ itemForm.exampleFile.name }}</div>
                    <small class="text-600">{{ formatFileSize(itemForm.exampleFile.size) }}</small>
                  </div>
                </div>
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (onClick)="clearCallback(); itemForm.exampleFile = null"
                  ariaLabel="Rimuovi file di esempio"
                ></p-button>
              </div>
              <p-button
                label="Scegli un Altro File"
                icon="pi pi-folder-open"
                (onClick)="chooseNewExampleFile(clearCallback, chooseCallback)"
                [outlined]="true"
                size="small"
                class="w-full mt-1"
                ariaLabel="Seleziona un file diverso"
              ></p-button>
            </div>
          } @else if (editingItemIndex !== null && items.at(editingItemIndex).get('exampleFileName')?.value) {
            <!-- File già presente sul server -->
            <div class="p-3">
              <div class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round mb-2 bg-blue-50">
                <div class="flex align-items-center gap-3">
                  <i class="pi pi-paperclip text-3xl text-blue-600" aria-hidden="true"></i>
                  <div>
                    <div class="font-semibold text-900">{{ items.at(editingItemIndex).get('exampleFileName')?.value }}</div>
                    <small class="text-600">già caricato</small>
                  </div>
                </div>
              </div>
              <p-button
                label="Sostituisci File"
                icon="pi pi-folder-open"
                (onClick)="chooseCallback()"
                [outlined]="true"
                size="small"
                class="w-full mt-1"
                ariaLabel="Seleziona un file sostitutivo"
              ></p-button>
            </div>
          } @else {
            <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
              <i class="pi pi-cloud-upload text-6xl mb-3 text-400" aria-hidden="true"></i>
              <p class="m-0 mb-2 font-semibold text-900">Trascina qui il file template</p>
              <p class="m-0 mb-3 text-sm text-600">oppure</p>
              <p-button
                label="Scegli File"
                icon="pi pi-folder-open"
                (onClick)="chooseCallback()"
                [outlined]="true"
                ariaLabel="Seleziona file template da caricare"
              ></p-button>
            </div>
          }
        </ng-template>
      </p-fileUpload>
      <small class="text-600 block mt-2">
        <strong>Dimensione massima:</strong> 10 MB
      </small>
    </div>
    }

    <!-- Riepilogo requisiti mancanti + pulsante conferma -->
    @if (!itemForm.label || itemForm.allowedTypes.length === 0) {
      <div class="flex align-items-start gap-2 p-3 mb-3 border-round bg-yellow-50 border-1 border-yellow-200" role="note" aria-live="polite">
        <i class="pi pi-info-circle text-yellow-600 mt-1" aria-hidden="true"></i>
        <div class="text-sm text-yellow-800">
          <strong>Per confermare compila:</strong>
          <ul class="m-0 pl-3 mt-1">
            @if (!itemForm.label) {
              <li>Nome documento</li>
            }
            @if (itemForm.allowedTypes.length === 0) {
              <li>Almeno un formato ammesso</li>
            }
          </ul>
        </div>
      </div>
    }

    <p-button
      [label]="editingItemIndex !== null ? 'Salva Modifiche' : 'Conferma'"
      icon="pi pi-check"
      class="w-full"
      (onClick)="saveItem()"
      [disabled]="!itemForm.label || itemForm.allowedTypes.length === 0"
      [attr.aria-label]="editingItemIndex !== null ? 'Salva modifiche al requisito documento' : 'Conferma e aggiungi requisito documento'"
      [pTooltip]="!itemForm.label || itemForm.allowedTypes.length === 0 ? 'Compila i campi obbligatori per confermare' : ''"
      tooltipPosition="top"
    ></p-button>
  </div>
</p-dialog>
</div> <!-- Close checklist-config-container -->
